import { User } from "../../../mp-database"
import { Roles } from "../../generic-utils"

const getHomePath = (user: User) => {
  if (user?.role === Roles.Student) {
    return "/student-experience"
  }

  if (user?.role === Roles.Course_Author) {
    return "/snap/author/mastery-lessons"
  }

  // @deprecated DEPRECATED_MANAGE_ORG_NAV — old `/manage/organization` nav usage; remove or repoint to `/reporting/organization` when that nav is deleted.
  return "/reporting"
}

export default getHomePath
